// A compact, thresholded coverage filter rounds pixel stair steps without blurring artwork.
// Run only while preparing masks, never in the animation loop.
export function smoothMaskAlpha(image){
 const {width:w,height:h,data}=image,alpha=new Uint8ClampedArray(w*h);
 for(let i=0;i<alpha.length;i++)alpha[i]=data[i*4+3];
 for(let y=0;y<h;y++)for(let x=0;x<w;x++){
  let sum=0;
  for(let dy=-1;dy<=1;dy++)for(let dx=-1;dx<=1;dx++){
   const sx=x+dx,sy=y+dy;
   if(sx>=0&&sx<w&&sy>=0&&sy<h)sum+=alpha[sy*w+sx]*(dx===0?2:1)*(dy===0?2:1);
  }
  const a=Math.max(0,Math.min(1,(sum/(16*255)-.15)/.7));
  data[(y*w+x)*4+3]=Math.round(255*a*a*(3-2*a));
 }
 return image;
}
